/**
 * Created by bartdecorte on 06/03/2017.
 */

var Util = {

	inArray: function(needle, haystack) {
		var i;
		for (i = 0; i < haystack.length; i++) {
			if (haystack[i] == needle) return true;
		}
		return false;
	}

};